import React from "react";
import { Paper, Typography } from "@material-ui/core";

// Vista previa aproximada (no es el HTML real de correo, es una
// aproximación visual en React) del correo de confirmación armado con el
// editor de bloques. Los bloques "de datos" de Dashport se muestran con
// datos de ejemplo (un atleta ficticio) ya que su contenido real solo existe
// al momento de enviar el correo a cada inscrito.
const ATLETA_EJEMPLO = {
  nombresYApellidos: "Ana Pérez",
  numero: "101",
  distancia: "10K",
  rama: "F",
  categoria: "Libre",
};

// El detalle de la compra siempre incluye la inscripción como producto,
// además de cualquier item extra que se haya comprado en el checkout.
const ORDEN_EJEMPLO = [
  { name: "Inscripción 10K", description: "Rama F - Libre", quantity: 1, unit_price: 500 },
  { name: "Playera conmemorativa", description: "Talla M", quantity: 1, unit_price: 150 },
];

function sustituirPlaceholders(texto, nombreEvento) {
  if (!texto) return "";
  return texto
    .split("[nombres]").join("Ana")
    .split("[apellidos]").join("Pérez")
    .split("{nombreEvento}").join(nombreEvento || "Nombre del evento");
}

function NotaBloqueCondicional({ texto }) {
  return (
    <div style={{ padding: 16, borderTop: "1px solid #eee" }}>
      <Typography variant="caption" style={{ opacity: 0.6, fontStyle: "italic" }}>
        {texto}
      </Typography>
    </div>
  );
}

function PreviewBloque({ block, eventDetail, color }) {
  const nombreEvento = eventDetail?.nombreEvento || "Nombre del evento";

  switch (block.type) {
    case "organizerHeader":
      return (
        <div style={{ background: color, padding: 24, textAlign: "center" }}>
          {eventDetail?.organizador?.logoOrganizador ? (
            <img src={eventDetail.organizador.logoOrganizador} alt="" style={{ maxWidth: 180, maxHeight: 100 }} />
          ) : (
            <Typography variant="body2" style={{ color: "#fff", opacity: 0.8 }}>
              (logo del organizador)
            </Typography>
          )}
        </div>
      );
    case "eventTitle":
      return (
        <div style={{ padding: 20, textAlign: "center" }}>
          <Typography variant="body2">Felicidades</Typography>
          <Typography variant="h6">
            <b>{ATLETA_EJEMPLO.nombresYApellidos}</b>
          </Typography>
          <Typography variant="body2">
            Completaste exitosamente el proceso de inscripción en el evento
          </Typography>
          <Typography variant="h6">
            <b>{nombreEvento}</b>
          </Typography>
        </div>
      );
    case "eventLogo":
      return (
        <div style={{ padding: 16, textAlign: "center" }}>
          {eventDetail?.logoEvento ? (
            <img src={eventDetail.logoEvento} alt="" style={{ maxWidth: 212 }} />
          ) : (
            <Typography variant="caption" style={{ opacity: 0.5 }}>(logo del evento)</Typography>
          )}
        </div>
      );
    case "confirmationLink":
      return (
        <div style={{ padding: 16, textAlign: "center", borderTop: "1px solid #eee" }}>
          <Typography variant="subtitle1">Importante</Typography>
          <Typography variant="body2" style={{ color: "#1976d2", textDecoration: "underline" }}>
            Descarga tu confirmación de inscripción aquí
          </Typography>
          <Typography variant="body2" style={{ marginTop: 10 }}>
            Consulta los datos del evento aquí
          </Typography>
        </div>
      );
    case "athleteData":
      return (
        <div style={{ padding: 16, textAlign: "center", borderTop: "1px solid #eee" }}>
          <Typography variant="subtitle1" gutterBottom>Datos inscripción</Typography>
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr>
                {["Número", "Evento", "Rama", "Categoria"].map((h) => (
                  <th key={h} style={{ fontSize: 12, padding: 4, opacity: 0.7 }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{ fontSize: 13, padding: 4 }}>{ATLETA_EJEMPLO.numero}</td>
                <td style={{ fontSize: 13, padding: 4 }}>{ATLETA_EJEMPLO.distancia}</td>
                <td style={{ fontSize: 13, padding: 4 }}>{ATLETA_EJEMPLO.rama}</td>
                <td style={{ fontSize: 13, padding: 4 }}>{ATLETA_EJEMPLO.categoria}</td>
              </tr>
            </tbody>
          </table>
        </div>
      );
    case "orderDetail":
      return (
        <div style={{ padding: 16, textAlign: "center", borderTop: "1px solid #eee" }}>
          <Typography variant="subtitle1" gutterBottom>Detalle de la compra</Typography>
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr>
                {["Producto", "Descripción", "Cantidad", "Precio"].map((h) => (
                  <th key={h} style={{ fontSize: 12, padding: 4, opacity: 0.7 }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {ORDEN_EJEMPLO.map((item) => (
                <tr key={item.name}>
                  <td style={{ fontSize: 13, padding: 4 }}>{item.name}</td>
                  <td style={{ fontSize: 13, padding: 4 }}>{item.description}</td>
                  <td style={{ fontSize: 13, padding: 4 }}>{item.quantity}</td>
                  <td style={{ fontSize: 13, padding: 4 }}>${item.unit_price * item.quantity} MXN</td>
                </tr>
              ))}
            </tbody>
          </table>
          <Typography variant="caption" style={{ display: "block", marginTop: 6, opacity: 0.6, fontStyle: "italic" }}>
            La inscripción siempre aparece aquí como un producto más; si el atleta compró algo
            adicional en el checkout (playera, kit, etc.) también sale en esta misma tabla.
          </Typography>
        </div>
      );
    case "paymentInfo":
      return (
        <NotaBloqueCondicional texto="Información de pago: solo aparece si el evento tiene ficha de pago pendiente o pago con tarjeta." />
      );
    case "footer":
      return (
        <div style={{ padding: 16, textAlign: "center", background: "#fafafa" }}>
          <Typography variant="caption">
            {eventDetail?.organizador?.nombreOrganizador || "Nombre del organizador"}
          </Typography>
        </div>
      );
    case "heading":
      return (
        <div style={{ padding: "10px 25px", textAlign: block.align || "left" }}>
          <Typography style={{ fontWeight: "bold", fontSize: block.size || 22 }}>
            {sustituirPlaceholders(block.text, nombreEvento)}
          </Typography>
        </div>
      );
    case "text":
      return (
        <div style={{ padding: "10px 25px", textAlign: block.align || "left" }}>
          <Typography style={{ fontSize: block.size || 14, color: block.color || "#111827", whiteSpace: "pre-wrap" }}>
            {sustituirPlaceholders(block.text, nombreEvento)}
          </Typography>
        </div>
      );
    case "button":
      return (
        <div style={{ padding: "12px 25px", textAlign: block.align || "center" }}>
          <span style={{ display: "inline-block", padding: "10px 20px", background: "#111827", color: "#fff", borderRadius: 4 }}>
            {block.text || "Botón"}
          </span>
        </div>
      );
    case "image":
      return (
        <div style={{ padding: "10px 25px", textAlign: block.align || "center" }}>
          {block.src ? (
            <img src={block.src} alt={block.alt || ""} style={{ maxWidth: "100%", width: block.width || 212 }} />
          ) : (
            <Typography variant="caption" style={{ opacity: 0.5 }}>(sin imagen)</Typography>
          )}
        </div>
      );
    case "link":
      return (
        <div style={{ padding: "10px 25px", textAlign: "center" }}>
          <Typography variant="body2" style={{ color: "#1976d2", textDecoration: "underline" }}>
            {block.value}
          </Typography>
        </div>
      );
    case "divider":
      return (
        <hr
          style={{
            margin: "10px 25px",
            border: 0,
            borderTop: `${block.thickness || 1}px solid ${block.color || "#e5e7eb"}`,
          }}
        />
      );
    case "spacer":
      return <div style={{ height: block.height || 16 }} />;
    default:
      return null;
  }
}

export default function EmailBlockPreview({ blocks, eventDetail }) {
  const color = (eventDetail && eventDetail.organizador && eventDetail.organizador.colorOrganizador) || "#111827";
  return (
    <Paper variant="outlined" style={{ maxWidth: 600, margin: "0 auto", overflow: "hidden" }}>
      {blocks.map((b) => (
        <PreviewBloque key={b.id} block={b} eventDetail={eventDetail} color={color} />
      ))}
    </Paper>
  );
}
